<template>
  <span style="padding: 1px">
    <b-tooltip
      :multilined="tooltipMultilined"
      :position="tooltipPosition"
      type="is-black"
      :append-to-body="true"
    >
      <b-tag
        :icon="tag.icon"
        :icon-pack="tag.iconPack ? tag.iconPack : 'fa'"
        size="is-small"
        :type="tag.type ? tag.type : 'is-light'"
        :style="backgroundColor(tag)"
        :closable="closable"
        @close="onClose($event)"
      >
        {{ tag.translate($i18n.locale) }}
      </b-tag>
      <template v-slot:content>
        {{ tag.translateInfo($i18n.locale) }}
      </template>
    </b-tooltip>
  </span>
</template>

<script>
import { Tag } from '@/models/transition/transition.js'

export default {
  name: 'ActionTag',
  props: {
    tag: {
      type: Tag,
      required: true
    },
    closable: {
      type: Boolean,
      required: false,
      default: false
    },
    tooltipPosition: {
      type: String,
      required: false,
      default: 'is-bottom'
    },
    tooltipMultilined: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['close'],
  methods: {
    onClose (e) {
      this.$emit('close', e)
    },
    backgroundColor (tag) {
      if (tag.color) {
        return `background-color: ${tag.color}; margin: 1px`
      }
      return ''
    }
  }
}
</script>
